<fa-icon
   kendoTooltip
   [title]="'brick.brick_definitions.directory_browser.columns.presence_status_note.title' | translate"
   [ngClass]="{ 'no-data': !(presenceNote$ | async) }"
   [icon]="(presenceNote$ | async) ? commentIcon : noCommentIcon"
   [fixedWidth]="fixedWidth"
></fa-icon>
{{ presenceNote$ | async }}
